import { render, staticRenderFns } from "./buyadd.vue?vue&type=template&id=7c2e5bf7&scoped=true&"
import script from "./buyadd.vue?vue&type=script&lang=js&"
export * from "./buyadd.vue?vue&type=script&lang=js&"
import style0 from "./buyadd.vue?vue&type=style&index=0&id=7c2e5bf7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2e5bf7",
  null
  
)

export default component.exports